module.exports = __webpack_public_path__ + "img/5_73.3eb7f6f4.png";